module.exports = __webpack_public_path__ + "img/koestraat.18d566c1.jpg";